<template>
  <form @submit.prevent="submit">
    <div class="row">
      <div class="form-group col-12">
        <w-input type="password" :model="$schema.password" />
      </div>

      <div class="form-group col-12">
        <w-input type="password" :model="$schema.repeat" />
      </div>

      <div class="col-12">
        <button type="submit" class="btn btn-danger float-right">
          {{ buttonText }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/password.schema';

// @vuese
// Formularz haseł
// @group Forms
export default {
  name: 'PasswordForm',
  mixins: [formMixin, notificationsMixin],
  props: {
    // Tekst przycisku
    buttonText: {
      type: String,
      required: false,
      default: 'Zapisz'
    }
  },
  data() {
    return {
      model: {
        password: '',
        repeat: ''
      }
    };
  },
  schema,
  methods: {
    // @vuese
    // Ustawia wpisane hasło
    submit() {
      if (!this.$schema.$validateAll().length) {
        this.$emit('setPassword', this.model.password);
      }
    }
  }
};
</script>

